import { makeAutoObservable, toJS } from 'mobx';
import { BFFGet } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { Platform } from '@/infrastructure/utils/app';
import { ConfigTabType, getDefaultConfig } from '@/presentation/pages/setting/app-deliver-config/api';
import {
  CONFIG_MODE,
  CONFIG_FIELD_INFO,
  OVERVIEW_CARDS_EXCLUDES,
  SDK_CONFIG,
} from '@/presentation/pages/setting/app-deliver-config/constant';
import { productService } from '@/service/product';

export class ConfigStore {
  configs: {[key: string]: any} = {};
  androidFullConfig = {};
  iosFullConfig = {};
  flutterFullConfig = {};
  windowsFullConfig = {};
  harmonyOSFullConfig = {};
  overviewCardsExcludeList: Record<string, string[]> = {};
  macFullConfig = {};
  appleTVFullConfig = {};
  issueRecommendOpen = false;
  overviewCardsExcludeListLoaded = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async loadOperation() {
    try {
      const { data: configMode } = await BFFGet(`/${API_PREFIX}/api/config/operation`, {
        params: {
          configName: CONFIG_MODE,
        },
      });
      const { data: configFieldInfo } = await BFFGet(`/${API_PREFIX}/api/config/operation`, {
        params: {
          configName: CONFIG_FIELD_INFO,
        },
      });
      const { data: sdkConfig } = await BFFGet(`/${API_PREFIX}/api/config/operation`, {
        params: {
          configName: SDK_CONFIG,
        },
      });
      const androidFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.Android);
      const iosFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.IOS);
      const flutterFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.Flutter);
      const windowsFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.Windows);
      const harmonyOSFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.HarmonyOS);
      const macFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.Mac);
      const appleTVFullConfig = await getDefaultConfig(ConfigTabType.DEFAULT, Platform.AppleTV);
      this.androidFullConfig = JSON.parse(androidFullConfig);
      this.iosFullConfig = JSON.parse(iosFullConfig);
      this.flutterFullConfig = JSON.parse(flutterFullConfig);
      this.windowsFullConfig = JSON.parse(windowsFullConfig);
      this.harmonyOSFullConfig = JSON.parse(harmonyOSFullConfig);
      this.macFullConfig =  JSON.parse(macFullConfig);
      this.appleTVFullConfig = JSON.parse(appleTVFullConfig);
      this.configs[CONFIG_MODE] = toJS(configMode);
      this.configs[CONFIG_FIELD_INFO] = toJS(configFieldInfo);
      this.configs[SDK_CONFIG] = toJS(sdkConfig);
    } catch (e) {
      logger.error('loadOperation err:', e);
    }
  }

  async loadOverviewCardsExcludeList() {
    if (this.overviewCardsExcludeListLoaded) {
      return;
    }

    try {
      const { data: excludeCardsList } = await BFFGet(`/${API_PREFIX}/api/config/operation`, {
        params: {
          configName: OVERVIEW_CARDS_EXCLUDES,
        },
      });

      this.overviewCardsExcludeList = excludeCardsList;
    } catch (e) {
      logger.error('loadOperation err:', e);
    } finally {
      this.overviewCardsExcludeListLoaded = true;
    }
  }

  async loadRecommendOpenStatus() {
    try {
      const status = await productService.getIssueRecommendationSetting({});
      this.issueRecommendOpen = status;
    } catch (e) {
      logger.error('loadOperation err:', e);
    }
  }

  public setIssueRecommendStatus(status: boolean) {
    this.issueRecommendOpen = status;
  }
}
